import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {Conf} from "../settings/config";
import {ShareButtons} from "@ngx-share/core";

@Component({
  selector: 'app-essential',
  templateUrl: './essential.component.html'
})
export class EssentialComponent implements OnInit {

  public slug;

  essential = {
    "title": null,
    "slug": null,
    "content": null,
    "thumbnail_image": null,
    "categories": []
  };


  constructor(public share: ShareButtons, private route: ActivatedRoute, private router: Router, private http: HttpClient, public _auth: AuthService) {

  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.slug = params['slug'];
      this.getEssential();
    });
  }

  getEssential() {
    this.http.get(Conf.API_URL + '/essentials/?slug=' + this.slug).subscribe(
        data => {
          if (data['results'].length) {
              this.essential = data['results'][0];
          } else {
            this.router.navigateByUrl('/404');
            return false;
          }
        },
        error => {
          console.log(error.error)
        }
    );
  }

}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/essential/essential.component.ts